import { render } from "./Card.vue?vue&type=template&id=582d434e&scoped=true"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=582d434e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582d434e"]])

export default __exports__